export default function shouldShowMarkersPanel(parm) {
  return (
    parm.gotCombatants &&
    parm.loadActionsReady &&
    !parm.toggleNumbers // &&
   // !parm.arena_extra_action_ready
  )
}
